import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { ITabsMenuProps } from '../components/tabs-menu/tabs-menu';
import { INavTabTextItemProps } from '../components/tabs-menu/nav-tab-text-item/nav-tab-text-item';
import { ITabContentItemProps } from '../components/tabs-menu/tab-content-item/tab-content-item';
import { NavTabTextItemModel } from './nav-tab-text-item-model';
import { TabContentItemModel } from './tab-content-item-model';

export class TabsMenuModel extends ContentItem {
  get navTabs(): INavTabTextItemProps[] {
    const getNavTabs = get(this._config, 'elements.nav_tabs.value', null);

    const transformNavTabs = getNavTabs
      ? getNavTabs.map((navTab: INavTabTextItem) =>
          NavTabTextItemModel.create(navTab)
        )
      : null;
    return transformNavTabs;
  }

  get tabContent(): ITabContentItemProps[] {
    const getTabContent = get(this._config, 'elements.tab_content.value', null);

    const transformTabContent = getTabContent
      ? getTabContent.map((tabContent: ITabContentItem) =>
          TabContentItemModel.create(tabContent)
        )
      : null;
    return transformTabContent;
  }

  public static create(data: ITabsMenu): ITabsMenuProps {
    const { navTabs, tabContent } = new TabsMenuModel(data);
    return {
      navTabs,
      tabContent
    };
  }
}
